import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';

@Component
export class QuickBuyButton extends ThemeComponent {
    @Prop({default: null}) freeGifts!: [];
    @Prop variantID!: number;

    init() {
        this.setEventListeners();
    }
    setEventListeners() {
        this.$listen(this, 'click', () => {

            const productItem = {
                id: this.variantID,
                quantity: 1
            };

            if (!this.freeGifts) {

                cart.addItem(productItem).catch((event: unknown | null) => {
                    if (event instanceof Error) {
                        this.$log.error('error', event.message);
                    }
                });

            } else {

                const giftIds = [];

                for(const freeGiftId of this.freeGifts) {
                    giftIds.push({
                        id: freeGiftId,
                        quantity: 1,
                        properties: {
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            _eligibleProductId: String(this.variantID)
                        }
                    });
                }

                const productWithGifts = [productItem, ...giftIds];

                cart.addItems(productWithGifts).catch((event: unknown | null) => {
                    if (event instanceof Error) {
                        this.$log.error('error', event.message);
                    }
                });
            }

            document.dispatchEvent(new Event('cartOpen'));
        });
    }
}
